

















import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UploadOptData, fileServer } from '@/api/common/upload'
import { AttachInfo, getInfo, remove, openFile } from '@/api/common/attach'
import { newGuid } from '@/configs/functions'

@Component
export default class singleFile extends Vue {
  @Prop({ default: false })
  public viewModel!: boolean
  @Prop({ default: 0 })
  public referId!: number
  @Prop({ default: 0 })
  public referType!: number
  @Prop({ default: '' })
  public tempGuid!: string
  @Prop({ default: '' })
  public fileExt!: string
  @Prop({ default: 0 })
  public fileSize!: number

  //每次调用组件都生成一个guid，用来在上传完成后的回传
  public uploadGuid: string = ''
  public opts: UploadOptData = {
    isMulti: false, //是否支持多个附件，以列表展示
    exts: this.fileExt, //格式限制 .pdf.doc.docx.png.jpg.gif
    refId: this.referId,
    refType: this.referType, // 从后台获取，refType=(byte)EnumHelper.AttachType.对应枚举
    guid: this.tempGuid // newGuid() // 从后台获取，guid=Guid.NewGuid().ToString()
  }
  public emptyForm: AttachInfo = {
    Id: 0,
    TempGuid: '',
    Name: '',
    Ext: '',
    Path: '',
    SavePath: '',
    Size: 0,
    Comments: ''
  }
  public form = Object.assign({}, this.emptyForm)

  public getFileUrl(f: AttachInfo) {
    return fileServer(f.Id, f.TempGuid, f.Name)
  }
  public fileClick(f: AttachInfo) {
    var fileUrl = fileServer(f.Id, f.TempGuid, f.Name)
    this.$emit('fileClick', { opts: this.opts, file: this.form })
    openFile(fileUrl, f.Name)
  }
  public getFileInfo() {
    var opt = this.opts
    getInfo(opt.refId, opt.refType, opt.guid)
      .then((response: { data: any }) => {
        this.form = response.data
        // const data: { opts: UploadOptData, file: AttachInfo }
        this.refresh()
      })
  }
  public refresh() {
    this.$emit('fileChange', { opts: this.opts, file: this.form })
  }
  public loadData() {
    this.getFileInfo()
  }
  public created() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
  }
  public mounted() {
    //按需加载, 传refer相关信息
    window.eventBus.$on('demandFile', (info: any) => {
      let opt = this.opts
      opt.refId = info.referId
      opt.refType = info.referType
      opt.guid = info.tempGuid
      this.getFileInfo()
    })
    window.eventBus.$on('uploadComplete', (info: any) => {
      if (info.targetId == this.uploadGuid) {
        this.opts = info.opt
        this.getFileInfo()
      }
    })
    this.$nextTick(() => {
      const opt = this.opts
      if ((opt.refType > 0 && opt.refId > 0) ||
        (opt.refType > 0 && opt.guid != '')) {
        this.getFileInfo()
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('uploadComplete')
  }
  //打开上传组件
  public showUploader() {
    if (this.uploadGuid == '') {
      this.uploadGuid = newGuid()
    }
    window.eventBus.$emit('openUploader', {
      targetId: this.uploadGuid,
      opt: this.opts,
      size: this.fileSize
    })
  }
  public delFile() {
    const id = this.form.Id
    if (id > 0) {
      this.$confirm(`此操作将永久删除该文件, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          remove(id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.form = Object.assign({}, this.emptyForm)
            this.refresh()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
